/**
 * Returns true if all the elements values are included in arr, false otherwise.
 */
const includesAll = (arr, values) => values.every((v) => arr.includes(v));

export default includesAll;
